// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ClaimResponseDocumentDTO } from '../models';
/**
 * ClaimResponseDocumentsApi - axios parameter creator
 * @export
 */
export const ClaimResponseDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Attach a Claim Response Document to a Claim 
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimResponseDocument(claimId: string, file: any, name: string, type: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling addClaimResponseDocument.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling addClaimResponseDocument.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling addClaimResponseDocument.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling addClaimResponseDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/claim-response-documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Document entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimResponseDocument(claimId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling deleteClaimResponseDocument.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling deleteClaimResponseDocument.');
            }
            const localVarPath = `/v2/claims/{claimId}/claim-response-documents/{documentId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Response Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimResponseDocumentById(claimId: string, documentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findClaimResponseDocumentById.');
            }
            // verify required parameter 'documentId' is not null or undefined
            if (documentId === null || documentId === undefined) {
                throw new RequiredError('documentId','Required parameter documentId was null or undefined when calling findClaimResponseDocumentById.');
            }
            const localVarPath = `/v2/claims/{claimId}/claim-response-documents/{documentId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Claim Response Documents for a Claim Response by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimResponseDocuments(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling findManyClaimResponseDocuments.');
            }
            const localVarPath = `/v2/claims/{claimId}/claim-response-documents`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimResponseDocumentsApi - functional programming interface
 * @export
 */
export const ClaimResponseDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Attach a Claim Response Document to a Claim 
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimResponseDocument(claimId: string, file: any, name: string, type: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimResponseDocumentDTO> {
            const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).addClaimResponseDocument(claimId, file, name, type, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Document entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimResponseDocument(claimId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).deleteClaimResponseDocument(claimId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Response Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimResponseDocumentById(claimId: string, documentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimResponseDocumentDTO> {
            const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).findClaimResponseDocumentById(claimId, documentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all Claim Response Documents for a Claim Response by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimResponseDocuments(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimResponseDocumentDTO>> {
            const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).findManyClaimResponseDocuments(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimResponseDocumentsApi - factory interface
 * @export
 */
export const ClaimResponseDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Attach a Claim Response Document to a Claim 
         * @param {string} claimId Claim id
         * @param {any} file 
         * @param {string} name 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClaimResponseDocument(claimId: string, file: any, name: string, type: string, options?: any) {
            return ClaimResponseDocumentsApiFp(configuration).addClaimResponseDocument(claimId, file, name, type, options)(axios, basePath);
        },
        /**
         * Delete a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Document entity id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClaimResponseDocument(claimId: string, documentId: string, options?: any) {
            return ClaimResponseDocumentsApiFp(configuration).deleteClaimResponseDocument(claimId, documentId, options)(axios, basePath);
        },
        /**
         * Get a Claim Response Document by id
         * @param {string} claimId Claim id
         * @param {string} documentId Claim Response Document id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findClaimResponseDocumentById(claimId: string, documentId: string, options?: any) {
            return ClaimResponseDocumentsApiFp(configuration).findClaimResponseDocumentById(claimId, documentId, options)(axios, basePath);
        },
        /**
         * Get all Claim Response Documents for a Claim Response by id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findManyClaimResponseDocuments(claimId: string, options?: any) {
            return ClaimResponseDocumentsApiFp(configuration).findManyClaimResponseDocuments(claimId, options)(axios, basePath);
        },
    };
};

/**
 * ClaimResponseDocumentsApi - interface
 * @export
 * @interface ClaimResponseDocumentsApi
 */
export interface ClaimResponseDocumentsApiInterface {
    /**
     * Attach a Claim Response Document to a Claim 
     * @param {string} claimId Claim id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApiInterface
     */
    addClaimResponseDocument(claimId: string, file: any, name: string, type: string, options?: any): AxiosPromise<ClaimResponseDocumentDTO>;

    /**
     * Delete a Claim Response Document by id
     * @param {string} claimId Claim id
     * @param {string} documentId Document entity id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApiInterface
     */
    deleteClaimResponseDocument(claimId: string, documentId: string, options?: any): AxiosPromise<{}>;

    /**
     * Get a Claim Response Document by id
     * @param {string} claimId Claim id
     * @param {string} documentId Claim Response Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApiInterface
     */
    findClaimResponseDocumentById(claimId: string, documentId: string, options?: any): AxiosPromise<ClaimResponseDocumentDTO>;

    /**
     * Get all Claim Response Documents for a Claim Response by id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApiInterface
     */
    findManyClaimResponseDocuments(claimId: string, options?: any): AxiosPromise<Array<ClaimResponseDocumentDTO>>;

}

/**
 * ClaimResponseDocumentsApi - object-oriented interface
 * @export
 * @class ClaimResponseDocumentsApi
 * @extends {BaseAPI}
 */
export class ClaimResponseDocumentsApi extends BaseAPI implements ClaimResponseDocumentsApiInterface {
    /**
     * Attach a Claim Response Document to a Claim 
     * @param {string} claimId Claim id
     * @param {any} file 
     * @param {string} name 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApi
     */
    public addClaimResponseDocument(claimId: string, file: any, name: string, type: string, options?: any) {
        return ClaimResponseDocumentsApiFp(this.configuration).addClaimResponseDocument(claimId, file, name, type, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Claim Response Document by id
     * @param {string} claimId Claim id
     * @param {string} documentId Document entity id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApi
     */
    public deleteClaimResponseDocument(claimId: string, documentId: string, options?: any) {
        return ClaimResponseDocumentsApiFp(this.configuration).deleteClaimResponseDocument(claimId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get a Claim Response Document by id
     * @param {string} claimId Claim id
     * @param {string} documentId Claim Response Document id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApi
     */
    public findClaimResponseDocumentById(claimId: string, documentId: string, options?: any) {
        return ClaimResponseDocumentsApiFp(this.configuration).findClaimResponseDocumentById(claimId, documentId, options)(this.axios, this.basePath);
    }

    /**
     * Get all Claim Response Documents for a Claim Response by id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimResponseDocumentsApi
     */
    public findManyClaimResponseDocuments(claimId: string, options?: any) {
        return ClaimResponseDocumentsApiFp(this.configuration).findManyClaimResponseDocuments(claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ClaimResponseDocumentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Attach a Claim Response Document to a Claim 
 * @param {string} claimId Claim id
 * @param {any} file 
 * @param {string} name 
 * @param {string} type 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addClaimResponseDocument(
    claimId: string,
    file: any,
    name: string,
    type: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimResponseDocumentDTO> {
    const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).addClaimResponseDocument(claimId, file, name, type, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Claim Response Document by id
 * @param {string} claimId Claim id
 * @param {string} documentId Document entity id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteClaimResponseDocument(
    claimId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).deleteClaimResponseDocument(claimId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Claim Response Document by id
 * @param {string} claimId Claim id
 * @param {string} documentId Claim Response Document id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findClaimResponseDocumentById(
    claimId: string,
    documentId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ClaimResponseDocumentDTO> {
    const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).findClaimResponseDocumentById(claimId, documentId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get all Claim Response Documents for a Claim Response by id
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findManyClaimResponseDocuments(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ClaimResponseDocumentDTO>> {
    const localVarAxiosArgs = ClaimResponseDocumentsApiAxiosParamCreator(configuration).findManyClaimResponseDocuments(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

